/* eslint-disable */

export const protobufPackage = "Reality.Reality.Api";

export enum WisePayoutStatus {
  /** WISE_PAYOUT_USER_VIEW_STATUS_UNKNOWN - デフォルト値として使用されるため、実際には使用しない */
  WISE_PAYOUT_USER_VIEW_STATUS_UNKNOWN = 0,
  /** WISE_PAYOUT_USER_VIEW_STATUS_PENDING - 送金準備中 */
  WISE_PAYOUT_USER_VIEW_STATUS_PENDING = 1,
  /** WISE_PAYOUT_USER_VIEW_STATUS_TRANSFERRED - 送金完了 */
  WISE_PAYOUT_USER_VIEW_STATUS_TRANSFERRED = 2,
  /** WISE_PAYOUT_USER_VIEW_STATUS_CANCELLED - 送金取消 */
  WISE_PAYOUT_USER_VIEW_STATUS_CANCELLED = 3,
  UNRECOGNIZED = -1,
}

export function wisePayoutStatusFromJSON(object: any): WisePayoutStatus {
  switch (object) {
    case 0:
    case "WISE_PAYOUT_USER_VIEW_STATUS_UNKNOWN":
      return WisePayoutStatus.WISE_PAYOUT_USER_VIEW_STATUS_UNKNOWN;
    case 1:
    case "WISE_PAYOUT_USER_VIEW_STATUS_PENDING":
      return WisePayoutStatus.WISE_PAYOUT_USER_VIEW_STATUS_PENDING;
    case 2:
    case "WISE_PAYOUT_USER_VIEW_STATUS_TRANSFERRED":
      return WisePayoutStatus.WISE_PAYOUT_USER_VIEW_STATUS_TRANSFERRED;
    case 3:
    case "WISE_PAYOUT_USER_VIEW_STATUS_CANCELLED":
      return WisePayoutStatus.WISE_PAYOUT_USER_VIEW_STATUS_CANCELLED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WisePayoutStatus.UNRECOGNIZED;
  }
}

export function wisePayoutStatusToJSON(object: WisePayoutStatus): string {
  switch (object) {
    case WisePayoutStatus.WISE_PAYOUT_USER_VIEW_STATUS_UNKNOWN:
      return "WISE_PAYOUT_USER_VIEW_STATUS_UNKNOWN";
    case WisePayoutStatus.WISE_PAYOUT_USER_VIEW_STATUS_PENDING:
      return "WISE_PAYOUT_USER_VIEW_STATUS_PENDING";
    case WisePayoutStatus.WISE_PAYOUT_USER_VIEW_STATUS_TRANSFERRED:
      return "WISE_PAYOUT_USER_VIEW_STATUS_TRANSFERRED";
    case WisePayoutStatus.WISE_PAYOUT_USER_VIEW_STATUS_CANCELLED:
      return "WISE_PAYOUT_USER_VIEW_STATUS_CANCELLED";
    case WisePayoutStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
